// extracted by mini-css-extract-plugin
module.exports = {"checkInputBox":"CheckBoxInput-module--checkInputBox--cVFqK","inputBox":"CheckBoxInput-module--inputBox--cRlKZ"};